<template>
  <!-- 卫星系列 -->
  <div class="satelliteList">
    <div v-for="(panel, index) in Totalpanels" :key="index">
      <myselfPanel :ref="'myselfPanel' + index" :panelIndex="panel.panelIndex" :panelName="panel.panelName"
        :contentData="panel.contentData" @currentCheckItem="allchekedfn"></myselfPanel>
    </div>
  </div>
</template>

<script>
import myselfPanel from "@/views/productSearch/mapTools/checkBox.vue"; //环境减灾\高分\资源系列
import comFun from "@/utils/function";
export default {
  name: "satelliteList",
  props: {
    currentResolve: {
      // 声明类型
      type: Array,
      //声明是否必需
      require: true,
      // 声明默认值
      default: [],
    },
    data: {
      // 声明类型
      type: Array,
      //声明是否必需
      require: true,
      // 声明默认值
      default: [],
    }
  },
  components: {
    myselfPanel,
  },
  watch: {
    currentResolve: {
      handler(newVal, oldVal) {
        console.log("当前传递接受到的分辨率选择参数：", newVal);
      },
      immediate: true,
    },
    data: {
      handler(newVal, oldVal) {
        console.log("当前传递卫星系列数据：", newVal);
        this.getSatelliteDataList = newVal;
         // 初始化卫星数据
        this.initSatellite(this.getSatelliteDataList);
      },
      immediate: true,
    },
  },
  data() {
    return {
      //存放复用组件的所有数据
      Totalpanels: [],
      getSatelliteDataList:[],
      // 存储传递过来的卫星id
      acceptSatelliteArray:[]
    };
  },
  created() {

  },
  mounted() {
   
  },
  methods: {

    initSatellite(acceptData) {
      // 1.将所有组件中的全选置为false
      if (this.Totalpanels.length) {
        this.Totalpanels.forEach((v, index) => {
          this.$refs['myselfPanel' + index][0].troggleAllcheckfn()
        })
      }
      // 2.置空所有卫星数据
      this.Totalpanels = []
      this.$store.dispatch('productSearch/updateSatelliteMap', []);
      console.log('当前存储的分辨率为：', this.$store.state.productSearch.resolution);
      // 目前暂时只拿第一个分辨率数据
      let response = acceptData;
      console.log('当前获取到的卫星系列数据：', response);
      response.forEach((ele, index) => {
        let obj = {
          panelIndex: String(index),
          panelName: ele.satelliteName,
          contentData: ele.sonSatelliteCategoryListVO
        };
        this.Totalpanels.push(obj);
      })
    },
    allchekedfn(allCurrent) {
      console.log(this.acceptSatelliteArray);
      if(this.acceptSatelliteArray.length > 0){
        let isSwitch = comFun.includes(this.acceptSatelliteArray,allCurrent);
        console.log(isSwitch);
        if(isSwitch == true){
          console.log('已存在所选卫星');
          allCurrent.map((item,index)=>{
            this.acceptSatelliteArray.map((items,indexs)=>{
              if(items == item){
                this.acceptSatelliteArray.splice(indexs,1);
              }
            })
          })
        }else{
          this.acceptSatelliteArray = this.acceptSatelliteArray.concat(allCurrent);
        }
      }else{
        this.acceptSatelliteArray = this.acceptSatelliteArray.concat(allCurrent);
        console.log(this.acceptSatelliteArray);
      }
      // console.log('当前存储的卫星系列：',this.acceptSatelliteArray);
      this.$store.dispatch('productSearch/updateSatelliteMap', this.acceptSatelliteArray)
    },
    // chooseNextLevel(item) {
    //   console.log('勾选等级传递参数：', item);
    //   if (item == '1') {
    //     console.log('单独勾选的特殊传感器，默认勾选L2：', this.insideFormLevel);
    //     this.insideFormLevel = 'L2';
    //   } else if (item == '2') {
    //     this.insideFormLevel = 'L1';
    //   }
    //   console.log('当前产品等级：', this.insideFormLevel);
    //   this.$store.dispatch('productSearch/updateProductLevel', this.insideFormLevel)
    // },
  },
};
</script>

<style lang="scss" scoped>
.satelliteList /deep/ .el-collapse-item__header {
  height: 36px !important;
  background-color: #a3b8e4;
}

.satelliteList /deep/ .el-collapse-item__content {
  padding-bottom: 10px !important;
}
</style>
